export const FETCH_BRANDS_REQUEST = 'FETCH_BRANDS_REQUEST';
export const FETCH_BRANDS_SUCCESS = 'FETCH_BRANDS_SUCCESS';
export const SAVE_BRAND_REQUEST = 'SAVE_BRAND_REQUEST';
export const SAVE_BRAND_SUCCESS = 'SAVE_BRAND_SUCCESS';
export const DELETE_BRAND_REQUEST = 'DELETE_BRAND_REQUEST';
export const DELETE_BRAND_SUCCESS = 'DELETE_BRAND_SUCCESS';

export const TERRITORIES = [
  {
    label: 'United States',
    value: 'US',
  },
  {
    label: 'Canada',
    value: 'CA',
  },
  {
    label: 'United Kingdom',
    value: 'GB',
  },
];

export const OFFER_PAYOUT_OPTIONS = [
  {
    value: -1,
    label: 'Use default values',
  },
  {
    value: 0,
    label: '0 days from sign up & 0 successful card transactions',
  },
  {
    value: 1,
    label: '30 days from sign up & 10 successful card transactions',
  },
  {
    value: 2,
    label: '60 days from sign up & 20 successful card transactions',
  },
  {
    value: 3,
    label: '90 days from sign up & 30 successful card transactions',
  },
];
